import React from "react";
import { useI18n } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";

export const Discretion = () => {
  const { t } = useI18n();
  return (
    <section className="py-28 md:py-40 border-b border-vm-border" data-testid="discretion-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="vm-label mb-6">{t("discretion.label")}</p>
          <h2 className="font-serif font-light leading-[1.05] text-4xl md:text-6xl mb-10">{t("discretion.title")}</h2>
          <p className="text-vm-text2 font-light leading-relaxed text-base md:text-lg">{t("discretion.body")}</p>
        </Reveal>
      </div>
    </section>
  );
};
